export default defineNuxtRouteMiddleware(async (to, from) => {
  // console.log('middleware: fetch user')
  // console.log('checking trailing slash...')
  // if (to.path.endsWith('/') && to.path !== '/') {
  //   console.log('---- removing slahings')
  //   return navigateTo({
  //     path: to.path.slice(0, -1),
  //     query: to.query
  //   }, { replace: true })
  // }
  const visitorSession = useVisitorSession()
  const user = useUser()
  const validSubPathes = {
    add_ticket: true,
    billing: true,
    profile: true,
    settings: true,
    support: true,
    tickets: true,
  } as const

  // return new Promise(navigateTo({
  //   path: `/dashboard/${visitorSession.id}/${to.params.userId}`,
  //   query: to.query
  // }))

  if ((to.params.userId as string)?.includes?.(',')) {
    return navigateTo({
      ...to,
      // @ts-ignore
      params: {
        ...to.params,
        userId: `${(to.params.userId as string).replace(/,/g, '')}`,
      }
    })
  }
  
  try {
    const paramsIsValidUserIdOrEmail = !isNaN(Number(to.params.userId)) || (to.params.userId?.includes('@') && to.params.userId?.includes('.'))
    // // for visits to dashboard, validate sub path and params.
    if (to.name === 'dashboard-userId') {
      // console.log('to.name === "dashboard-userId"', paramsIsValidUserIdOrEmail)
      if (validSubPathes[String(to.params.userId)]) {
        // user is visiting /dashboard/[support|profile|...], redirect to /dashboard/${userId}/support
        // console.log(`redirecting to /dashboard/${visitorSession.id}/${to.params.userId}`)
        const newDest = {
          path: `/dashboard/${visitorSession.id}/${to.params.userId}`,
          query: to.query
        }
        // console.log('newDest 1:', newDest)

        return navigateTo(newDest)
      } else 
      // not a valid subpath, redirect to /dashboard/${visitorSession.id}
        if (!paramsIsValidUserIdOrEmail) {
          // console.log(`to.params.userId is '${String(to.params.userId)}' not a valid subpath, redirecting to /dashboard/${visitorSession.id}`)
          const newDest = {
            path: `/dashboard/${visitorSession.id}`,
            query: to.query
          }
          // console.log('newDest 2:', newDest)
          // return
          return navigateTo(newDest)
        }
    }

    // console.log('22222')


    // determine which user to fetch.
    if (visitorSession.realAdmin) {
      // console.log('is real admin, checking which id to fetch')
      // admin, fetch user by query.asUser
      if (paramsIsValidUserIdOrEmail) {
        // console.log('fetching user by params.userId:', to.params.userId)
        await user.get({ id: String(to.params.userId) })
      } else if (to.query.asUser) {
        // console.log('fetching user by query.asUser:', to.query.asUser)
        await user.get({ id: Number(to.query.asUser) })
      } else {
        // console.log('???? no valid params.userId or query.asUser, use session data as user data')
        user.setUserData(visitorSession.$state as any)
      }
    } else {
      // not admin, skip fetch, always use session data as user data
      // console.log('not admin, skip fetch, use session data as user data')
      user.setUserData(visitorSession.$state as any)
    }
  } catch (e: any) {
    console.log('middleware one error catched', e)
    if (!useIsBrowser()) {
      return { path: `/dashboard/${visitorSession.user_id}`, query: to.query }
    }
    useFullscreenLoading().close()
    useDialog().alert({
      title: `获取用户 ${to.params.userId || to.query.asUser} 信息失败`,
      body: e?.data?.message || JSON.stringify(e, null, 2),
      confirmButtonText: '确认',
    })
    if (from.fullPath !== to.fullPath) {
      return from
    }
    abortNavigation()
  }
})
